import { useEffect as r } from "react";
import { SegmentHandler as a } from "./index2.js";
function n() {
  try {
    a.instance.page();
  } catch (e) {
    console.error("[Segment] Error tracking page view:", e.message);
  }
}
function c(e) {
  r(() => {
    n();
  }, [...e ?? []]);
}
export {
  c as useTrackPage
};
//# sourceMappingURL=index5.js.map
